import CustomTextField from "components/CustomTextField";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Button, Row, Col, Spinner, Label } from "reactstrap";
import { CMS_maati } from "urlconfig";

const EditProjectFarmer = ({ farmer, documentId, onClose, page, pageSize }) => {
  const [loading, setLoading] = useState(false);
  const [locationData, setLocationData] = useState([]);

  const [farmerData, setFarmerData] = useState({
    name_of_respondent: "",
    mobile_number: "",
    gender: "",
    age: "",
    education_level: "",
    number_of_members: "",
    name_of_household_head: "",
    number_of_crops_cultivated: "",
    total_landholding: "",
    district: "",
    block: "",
    grampanchayat: "",
    address: "",
    total_years_in_farming:"",
    primary_type_of_agriculture_operation:""

  });

  useEffect(() => {
    fetch(
      "https://lc-research-projects.s3.ap-south-1.amazonaws.com/maati/baseline/master_data_mapping.json"
    )
      .then((res) => res.json())
      .then((data) => setLocationData(data))
      .catch((err) => console.error("Error fetching location data:", err));
  }, []);

  useEffect(() => {
    if (farmer) {
      setFarmerData((prev) => ({
        ...prev,
        name_of_respondent: farmer.name_of_respondent || "",
        mobile_number: farmer.mobile_number || "",
        gender: farmer.gender || "",
        age: farmer.age || "",
        education_level: farmer.education_level || "",
        number_of_members: farmer.number_of_members || "",
        name_of_household_head: farmer.name_of_household_head || "",
        number_of_crops_cultivated: farmer.number_of_crops_cultivated || "",
        total_landholding: farmer.total_landholding || "",
        district: farmer.district || "",
        block: farmer.block || "",
        grampanchayat: farmer.grampanchayat || "",
        address: farmer.address || "",
        total_years_in_farming:farmer.total_years_in_farming,
        primary_type_of_agriculture_operation:farmer.primary_type_of_agriculture_operation
        
      }));
    }
  }, [farmer]);

  const handleInputChange = (e) => {
    setFarmerData({ ...farmerData, [e.target.name]: e.target.value });
  };

  const districts = locationData.map((d) => d.label);

  const blocks =
    locationData
      .find((d) => d.label === farmerData.district)
      ?.blocks.map((b) => b.label) || [];

  const gps =
    locationData
      .find((d) => d.label === farmerData.district)
      ?.blocks.find((b) => b.label === farmerData.block)
      ?.GPs.map((gp) => gp.label) || [];

  const majras =
    locationData
      .find((d) => d.label === farmerData.district)
      ?.blocks.find((b) => b.label === farmerData.block)
      ?.GPs.find((gp) => gp.label === farmerData.grampanchayat)
      ?.majras.map((m) => m.label) || [];

  const handleDistrictChange = (e) => {
    setFarmerData({
      ...farmerData,
      district: e.target.value,
      block: "",
      grampanchayat: "",
      address: "",
    });
  };

  const handleBlockChange = (e) => {
    setFarmerData({
      ...farmerData,
      block: e.target.value,
      grampanchayat: "",
      address: "",
    });
  };

  const handleGpChange = (e) => {
    setFarmerData({
      ...farmerData,
      grampanchayat: e.target.value,
      address: "",
    });
  };

  const handleMajraChange = (e) => {
    setFarmerData({
      ...farmerData,
      address: e.target.value,
    });
  };

  const refetchFarmerDetails = async () => {
    try {
      const params = new URLSearchParams();
      params.append("pagination[page]", page);
      params.append("pagination[pageSize]", pageSize);
      params.append("sort[0]", "createdAt:desc");

      const res = await fetch(
        `${CMS_maati}/api/farmer-basic-details?${params.toString()}`
      );
      const updated = await res.json();
      return updated?.data;
    } catch (err) {
      console.error("Failed to refetch farmer:", err);
      return null;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await fetch(`${CMS_maati}/api/farmer-basic-details/${documentId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ data: farmerData }),
      });

      toast.success("Farmer details updated successfully");
      await refetchFarmerDetails();
      onClose();
    } catch (error) {
      console.error("Error updating farmer:", error);
      toast.error("Failed to update farmer");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="py-2" onSubmit={handleSubmit}>
      <Row className="d-flex g-3">
        <Col lg="4">
          <CustomTextField
            label="Respondent Name"
            name="name_of_respondent"
            value={farmerData.name_of_respondent}
            onChange={handleInputChange}
          />
        </Col>

        <Col lg="4">
          <CustomTextField
            label="Mobile Number"
            type="number"
            name="mobile_number"
            value={farmerData.mobile_number}
            onChange={handleInputChange}
          />
        </Col>

        <Col lg="4">
          <Label>Gender *</Label>
          <select
            className="form-control"
            name="gender"
            value={farmerData.gender}
            onChange={handleInputChange}
            style={{
              padding: "12px",
              fontSize: "14px",
              borderRadius: "3px",
              appearance: "auto",
            }}
          >
            <option value="">Select</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Others">Others</option>
          </select>
        </Col>

        <Col lg="4">
          <CustomTextField
            label="Age"
            name="age"
            value={farmerData.age}
            onChange={handleInputChange}
          />
        </Col>

        <Col lg="4">
          <Label>Education Level *</Label>
          <select
            className="form-control"
            name="education_level"
            value={farmerData.education_level}
            onChange={handleInputChange}
            style={{
              padding: "12px",
              fontSize: "14px",
              borderRadius: "3px",
              appearance: "auto",
            }}
          >
            <option value="">Select</option>
            <option value="Primary">Primary</option>
            <option value="Secondary">Secondary</option>
            <option value="Graduation">Graduation</option>
            <option value="Post Graduation">Post Graduation</option>
            <option value="No Formal Education">No Formal Education</option>
          </select>
        </Col>

        <Col lg="4">
          <CustomTextField
            label="Family Members"
            name="number_of_members"
            value={farmerData.number_of_members}
            onChange={handleInputChange}
          />
        </Col>

        <Col lg="4">
          <CustomTextField
            label="Household Head"
            name="name_of_household_head"
            value={farmerData.name_of_household_head}
            onChange={handleInputChange}
          />
        </Col>

        <Col lg="4">
          <CustomTextField
            label="Crops Cultivated"
            name="number_of_crops_cultivated"
            value={farmerData.number_of_crops_cultivated}
            onChange={handleInputChange}
          />
        </Col>
        
         <Col lg="4">
          <CustomTextField
            label="Total Landholding"
            name="total_landholding"
            value={farmerData.total_landholding}
            onChange={handleInputChange}
          />
        </Col>
         <Col lg="4">
          <CustomTextField
            label="Total Year in Farming"
            name="total_years_in_farming"
            value={farmerData.total_years_in_farming}
            onChange={handleInputChange}
          />
        </Col>
        <Col lg="4">
          <CustomTextField
            label="Primary Type of Agriculture Operation"
            name="primary_type_of_agriculture_operation"
            value={farmerData.primary_type_of_agriculture_operation}
            onChange={handleInputChange}
          />
        </Col>

        <Col lg="4">
          <Label>District</Label>
          <select
            className="form-control"
            value={farmerData.district}
            onChange={handleDistrictChange}
            style={{
              padding: "12px",
              fontSize: "14px",
              borderRadius: "3px",
              appearance: "auto",
            }}
          >
            <option value="">Select District</option>
            {districts.map((d) => (
              <option key={d}>{d}</option>
            ))}
          </select>
        </Col>

        <Col lg="4">
          <Label>Block</Label>
          <select
            className="form-control"
            value={farmerData.block}
            onChange={handleBlockChange}
            disabled={!farmerData.district}
            style={{
              padding: "12px",
              fontSize: "14px",
              borderRadius: "3px",
              appearance: "auto",
            }}
          >
            <option value="">Select Block</option>
            {blocks.map((b) => (
              <option key={b}>{b}</option>
            ))}
          </select>
        </Col>

        <Col lg="4">
          <Label>Gram Panchayat</Label>
          <select
            className="form-control"
            value={farmerData.grampanchayat}
            onChange={handleGpChange}
            disabled={!farmerData.block}
            style={{
              padding: "12px",
              fontSize: "14px",
              borderRadius: "3px",
              appearance: "auto",
            }}
          >
            <option value="">Select GP</option>
            {gps.map((gp) => (
              <option key={gp}>{gp}</option>
            ))}
          </select>
        </Col>
        <Col lg="4">
          <Label>Village</Label>
          <select
            className="form-control"
            value={farmerData.address}
            onChange={handleMajraChange}
            disabled={!farmerData.grampanchayat}
            style={{
              padding: "12px",
              fontSize: "14px",
              borderRadius: "3px",
              appearance: "auto",
            }}
          >
            <option value="">Select Village</option>
            {majras.map((m) => (
              <option key={m}>{m}</option>
            ))}
          </select>
        </Col>
      </Row>

      <div className="d-flex justify-content-center mt-3">
        <Button
          type="submit"
          className="bg-success border-0 d-flex align-items-center gap-2"
          disabled={loading}
        >
          {loading && <Spinner size="sm" />}
          {loading ? "Saving..." : "Submit"}
        </Button>
      </div>
    </form>
  );
};

export default EditProjectFarmer;
